import type { TFunction } from 'i18next'
import {
  TYPE_B_STANDARD_MAPPING_BY_REFERENCE,
  buildTypeBMappingReasonText,
  type TypeBConditionSuffixKey,
} from '@artem-lex/common-server/type-b-standard-mapping'

const REASON_PHRASE_PREFIX = 'onboarding.typeBCandidates.reasonPhrases.'
const REASON_TEMPLATE_PREFIX = 'onboarding.typeBCandidates.reasonTemplates.'

export function buildTypeBCandidateExplanation(
  reference: string,
  translate: TFunction<'machineryDirectiveCompliance', undefined>,
  fallbackExplanation?: string
): string {
  const mappingRow = TYPE_B_STANDARD_MAPPING_BY_REFERENCE.get(reference)
  if (mappingRow == null) {
    return fallbackExplanation?.trim() ?? ''
  }

  return buildTypeBMappingReasonText({
    when: mappingRow.when,
    conditionSuffixKey: mappingRow.conditionSuffixKey,
    resolvePhrase: (phraseKey) => {
      return translate(`${REASON_PHRASE_PREFIX}${phraseKey}`)
    },
    templates: {
      alwaysApplicable: translate(`${REASON_TEMPLATE_PREFIX}alwaysApplicable`),
      basedOnAnswers: (triggerPhrase) => {
        return translate(`${REASON_TEMPLATE_PREFIX}basedOnAnswers`, {
          triggers: triggerPhrase,
        })
      },
      conditionSuffix: (suffixKey: TypeBConditionSuffixKey) => {
        return translate(
          `${REASON_TEMPLATE_PREFIX}conditionSuffix.${suffixKey}`
        )
      },
    },
  })
}
